import $ from 'jquery';
import selectize from 'selectize';

import Vars from '../../vars';

import YandexMap from './../../classes/YandexMap';
import Action from './../classes/Action';
import Dropzone from "./../classes/Dropzone";
import Validation from './../classes/Validation';

import Modal from './../../components/Modal';
import Request from './../../components/request';
import Utils from './../../components/utils';

import DropzoneBuilding from './../dropzone/building';

import Chess from "./Chess";
import Progress from "./Progress";
import Company from "./Company";

class Building {
    constructor(args) {
        let self = this;

        self._setArgs(args);
        self._init(args);
    }

    _elems = {
        $content : $(),
        $create  : $(),
        $edit    : $(),
        $modal   : $(),
        $form    : $()
    };

    _const = {
        entities : 'buildings',
        entity   : 'building',
        title : {
            add  : 'Добавление нового дома',
            edit : 'Редактирование дома'
        },
        parent   : {
            entities : 'objects',
            entity   : 'object',
        }
    };

    _state = {
        item     : {},
        items    : {},
        object   : {},
        chess    : {},
        modal    : {},
        dropzone : {},
        ajax     : {},
        tariff   : {}
    };

    _args = {
        mode     : '',
        objectId : 0,
        id       : 0
    };

    _utils = {
        validation : {}
    };

    _actions = {
        activate : {
            title: 'Активация дома',
            content : function(args){
                let self = args.self;
                if (!self) return;

                return Utils.renderProfileTemplate(self._const.entity + '-activate-confirmation', {
                    [self._const.entity]: self._state.item
                })
            },
            section : {
                entities : 'sections',
                title    : 'Активация подъезда',
                confirmation : {
                    title: 'этот подъезд'
                }
            }
        },
        deactivate : {
            title: 'Деактивация дома',
            section : {
                entities : 'sections',
                title    : 'Деактивация подъезда',
                confirmation : {
                    title: 'этот подъезд'
                }
            }
        },
        remove : {
            title: 'Удаление дома',
            section : {
                entities : 'sections',
                title    : 'Удаление подъезда',
                confirmation : {
                    title: 'этот подъезд'
                }
            }
        },
        confirmation : {
            title: 'этот дом'
        },
        done : {
            activate : function(args) {
                let self = args.self;
                self._state.item   = args[self._const.entity];
                self._state.object = self._state.item.object;

                let dropdown = Utils.renderProfileTemplate(self._const.entity + '-dropdown', {
                    object   : self._state.object,
                    building : self._state.item,
                    tariff   : self._state.tariff
                });

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Жилые комплексы',
                            href  : '#objects'
                        },
                        {
                            title : self._state.object.name,
                            href  : '#objects/' + self._state.object.id
                        },
                        {
                            title : self._state.item.name ? self._state.item.name : 'Дом №' + self._state.item.number
                        }
                    ],
                    dropdown : dropdown,
                    activate : {
                        id        : self._state.item.id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    object               : self._state.object,
                    [self._const.entity] : self._state.item,
                    tariff               : self._state.tariff
                }));

                window.chess = self._state.chess = new Chess({
                    object               : self._state.object,
                    [self._const.entity] : self._state.item,
                    progress             : self._state.progress,
                    buildingSelf         : self
                });

                $('.aside').trigger('update');

                self._bindElements();
                self._bindUI();

                self._bindActions();

                self._state.progress.update({
                    object : self._state.object
                });
            },
            deactivate : function(args) {
                let self = args.self;
                self._state.item   = args[self._const.entity];
                self._state.object = self._state.item.object;

                let dropdown = Utils.renderProfileTemplate(self._const.entity + '-dropdown', {
                    object   : self._state.object,
                    building : self._state.item,
                    tariff   : self._state.tariff
                });

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Жилые комплексы',
                            href  : '#objects'
                        },
                        {
                            title : self._state.object.name,
                            href  : '#objects/' + self._state.object.id
                        },
                        {
                            title : self._state.item.name ? self._state.item.name : 'Дом №' + self._state.item.number
                        }
                    ],
                    dropdown : dropdown,
                    activate : {
                        id        : self._state.item.id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    object               : self._state.object,
                    [self._const.entity] : self._state.item,
                    tariff               : self._state.tariff
                }));

                window.chess = self._state.chess = new Chess({
                    object               : self._state.object,
                    [self._const.entity] : self._state.item,
                    progress             : self._state.progress,
                    buildingSelf         : self
                });

                $('.aside').trigger('update');

                self._bindElements();
                self._bindUI();

                self._bindActions();

                self._state.progress.update({
                    object : self._state.object
                });
            },
            remove: {
                building : function(args) {
                    let self = args.self;
                    if (self._args.mode == Vars.view.object) {
                        window.location.reload();
                    }
                },

                section: function(args){
                    let self = args.self;
                    self._state.item   = args[self._const.entity];
                    self._state.object = self._state.item.object;

                    window.chess = self._state.chess = new Chess({
                        object               : self._state.object,
                        [self._const.entity] : self._state.item,
                        progress             : self._state.progress,
                        buildingSelf         : self
                    });

                    self._bindElements();
                    self._bindUI();

                    self._bindActions();

                    self._state.progress.update({
                        object : self._state.object
                    });
                }
            }
        }
    };

    _setArgs = (args) => {
        let self = this;

        self._args.mode     = args.mode;
        self._args.objectId = args.objectId;
        self._args.id       = args.id;

        self._state.object  = args.object || self._state.object;
    };

    _setValidation = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._utils.validation = new Validation({
            form : self._elems.$form
        });
    };

    _setDropzone = () => {
        let self = this;

        self._state.dropzone.items = DropzoneBuilding.get({
            item     : self._state.item,
            parent   : self._state.object,
            entities : self._const.entities
        });
        self._state.dropzone.entity = self._state.item;
    };

    _initMap = () => {
        let self = this;

        let $mapBlock = self._elems.$modal.find('.js-map');
        if (!$mapBlock.length) return;
        if(typeof ymaps === undefined || typeof ymaps === "undefined"){
            $mapBlock.prev('.form__field__error').show();
            $mapBlock.hide();
        }
        else {
            ymaps.ready(function () {
                if (Object.keys(self._state.item).length && self._state.item.location.length > 0) {
                    $mapBlock
                        .data('location', self._state.item.location.join(','))
                        .data('zoom', 16);

                    self._state.map = new YandexMap({
                        root : $mapBlock,
                        args : {
                            afterRender : function(args) {
                                if (!args.map) return;

                                args.map.events.add('actionend', function() {
                                    const location = args.map.getCenter();
                                    let $locationInput = self._elems.$modal.find('input[name="building[location]"]');
                                    if (!$locationInput.length) return;
                                    $locationInput.val(location.join(','));
                                    $locationInput.parents('.form-field').removeClass('error');
                                    self._bindSubways();
                                    self._bindDistricts();
                                });
                            }
                        }
                    });
                }
                else {
                    ymaps.geocode((Object.keys(self._state.item).length ? self._state.item.address : '') || self._state.object.address || 'Москва', {
                        results: 1
                    }).then(function (response) {
                        const firstGeoObject = response.geoObjects.get(0);

                        if (firstGeoObject) {
                            const coordinates = firstGeoObject.geometry.getCoordinates();
                            $mapBlock
                                .data('location', coordinates.join(','))
                                .data('zoom', 9);
                        }
                        else {
                            $mapBlock
                                .data('location', '55.751574,37.573856')
                                .data('zoom', 9);
                        }

                        self._state.map = new YandexMap({
                            root : $mapBlock,
                            args : {
                                afterRender : function(args) {
                                    if (!args.map) return;

                                    args.map.events.add('actionend', function() {
                                        const location = args.map.getCenter();
                                        let $locationInput = self._elems.$modal.find('input[name="building[location]"]');
                                        if (!$locationInput.length) return;
                                        $locationInput.val(location.join(','));
                                        $locationInput.parents('.form-field').removeClass('error');
                                        self._bindSubways();
                                        self._bindDistricts();
                                    });
                                }
                            }
                        });
                    });
                }
            });
        }
    };

    _initModal = (args) => {
        let self = this;

        self._setDropzone();

        self._elems.$modal = new Modal({
            title   : Object.keys(self._state.item).length ? self._const.title.edit : self._const.title.add,
            content : Utils.renderProfileTemplate(self._const.entity + '-form', {
                [self._const.entity] : Object.keys(self._state.item).length ? self._state.item : null,
                object               : self._state.object,
                options              : args
            }),
            closingConfirmation : true,
            dropzone : self._state.dropzone,
            confirm  : function(args){
                self._bindSubmit(args);
            },
            closed   : function() {
                //self.yMap && self.yMap.destroy();
            }
        });

        self._elems.$form = self._elems.$modal.find('form');

        self._bindForm();
        self._bindCompanies({
            companies : args.companies
        });

    };

    _bindForm = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._initMap();
        self._bindAddress();
        self._setValidation();
        self._updateForm();
        self._updatePreview();

        self._elems.$form.find('input[name="building[name]"]').keyup(function() {
            self._updatePreview();
        });

        self._elems.$form.find('input[name="building[video_link]"]').change(function() {
            $(this).parents('.form-field').removeClass('error');
            $(this).parent().next('.form-field__message').empty();
        });
        self._elems.$form.find('input[name="building[video_link]"]').keyup(function() {
            $(this).parents('.form-field').removeClass('error');
            $(this).parent().next('.form-field__message').empty();
        });

        if (!Object.keys(self._state.item).length) return;

        self._bindBanks();
        self._bindSubways();
        self._bindDistricts();
    };

    _updatePreview = () => {
        let self  = this;

        if (!self._elems.$form.length) return;

        const number = self._elems.$form.find('input[name="building[number]"]').val();
        const name   = self._elems.$form.find('input[name="building[name]"]').val();

        if (name != '') {
            self._elems.$form.find('.form-text-preview').text('Дом ' + name).slideDown();
        } else if (number != '') {
            self._elems.$form.find('.form-text-preview').text('Дом ' + number).slideDown();
        } else {
            self._elems.$form.find('.form-text-preview').text('Дом...').slideUp();
        }
    };

    _updateForm = (args) => {
        let self        = this;

        if (!self._elems.$form.length) return;

        const checks = {
            has_mortgage    : self._elems.$form.find('.form-field[data-name="has_mortgage"] .checkbox').hasClass('checked'),
            has_installment : self._elems.$form.find('.form-field[data-name="has_installment"] .checkbox').hasClass('checked')
        };

        if (checks.has_mortgage) {
            self._elems.$form.find('.form-field[data-name="minimum_mortgage_rate"]').show();
            self._elems.$form.find('.form-field[data-name="no_initial_contribution"]').show();
            self._elems.$form.find('.form-field[data-name="bank_element_ids"]').show();
            self._elems.$form.find('.form-highlight[data-name="mortgage"]').show();
        }
        else {
            self._elems.$form.find('.form-field[data-name="minimum_mortgage_rate"]').hide();
            self._elems.$form.find('.form-field[data-name="no_initial_contribution"]').hide();
            self._elems.$form.find('.form-field[data-name="bank_element_ids"]').hide();
            self._elems.$form.find('.form-highlight[data-name="mortgage"]').hide();
        }

        if (checks.has_installment) {
            self._elems.$form.find('.form-group[data-name="installment_period"]').show();
            self._elems.$form.find('.form-field[data-name="interest_free_installment"]').show();
            self._elems.$form.find('.form-highlight[data-name="installment"]').show();
        }
        else {
            self._elems.$form.find('.form-group[data-name="installment_period"]').hide();
            self._elems.$form.find('.form-field[data-name="interest_free_installment"]').hide();
            self._elems.$form.find('.form-highlight[data-name="installment"]').hide();
        }

        if (self._state.countOfExtraCompanies == 0) {
            self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__link.remove').hide();
        } else {
            self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__link.remove').show();
        }

        let $link = args && args.link || $();

        if ($link.length) {
            if ($link.hasClass('select__remove')){
                let $parent = $link.parents('.form-group__section');
                if ($parent.index() == 0){
                    $parent.hide();
                    self._elems.$form.find('select[name="building[extra_company0_id]"]').val('');
                    self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__link.add.is-add-company.is-first').show();
                } else if ($parent.index() == 1){
                    $parent.hide();
                    self._elems.$form.find('select[name="building[extra_company1_id]"]').val('');
                    self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__link.add.is-add-company.is-second').show();
                }
            }
            else {
                if ($link.index() == 1) {
                    self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__section.is-first').show();
                    $link.hide();
                } else if ($link.index() == 2) {
                    self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__section.is-second').show();
                    $link.hide();
                }
            }
        }
        else {
            if (Object.keys(self._state.item).length && self._state.item.extra_companies && self._state.item.extra_companies[0]) {
                self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__link.add.is-add-company.is-first').hide();
                self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__section.is-first').show();
            }
            else {
                self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__link.add.is-add-company.is-first').show();
                self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__section.is-first').hide();
            }
            if (Object.keys(self._state.item).length && self._state.item.extra_companies && self._state.item.extra_companies[1]) {
                self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__link.add.is-add-company.is-second').hide();
                self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__section.is-second').show();
            }
            else {
                self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__link.add.is-add-company.is-second').show();
                self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__section.is-second').hide();
            }
        }
    };

    _bindElements = () => {
        let self = this;

        self._elems.$content = !self._elems.$content.length ? $('.content') : self._elems.$content;
        if(!self._elems.$content.length) return;

        self._elems.$create = self._elems.$content.find('.js-profile-building-create');
        self._elems.$edit   = self._elems.$content.find('.js-profile-building-edit');
    };

    _bindProgress = () => {
        let self = this;

        self._state.progress = new Progress();
        self._state.progress.update({
            object : self._state.object
        });
    };

    _bindActions = () => {
        let self = this;

        if (self._args.mode == Vars.view.object) return;

        new Action({
            id       : self._state.item.id,
            actions  : self._actions,
            entities : self._const.entities,
            entity   : self._const.entity,
            prefix   : 'objects/' + self._state.item.object_id,
            self     : self
        });
    };

    _bindAddress = () => {
        let self = this;

        self._elems.$form.find('input[name="building[address_number]"]').on('keyup', function(e) {
            const addressNumber = $(this).val();
            const addressElementId = self._elems.$form.find('input[name="building[address_element_id]"]').val();
            if (!addressElementId) return;

            const address = self._elems.$form.find('.form-field[data-name="address"] .input input[type="text"]').val();
            if (!address) return;

            ymaps.ready(function() {
                ymaps.geocode(address + (addressNumber ? ' ' + addressNumber : ''), {
                    results: 1,
                }).then(function(response) {
                    const firstGeoObject = response.geoObjects.get(0);
                    if(!firstGeoObject) return;

                    const coordinates = firstGeoObject.geometry.getCoordinates();
                    self._state.map.setCenter(coordinates, 16);
                    self._elems.$form.find('input[name="building[location]"]').val(coordinates.join(','));
                });
            });
        });

        self._elems.$form.find('.form-field[data-name="address"] .input').change(function() {
            const addressNumber = self._elems.$form.find('input[name="building[address_number]"]').val();
            const address = $(this).find('input[type="text"]').val();

            if (!address) return;

            ymaps.ready(function() {
                ymaps.geocode(address + (addressNumber ? ' ' + addressNumber : ''), {
                    results: 1,
                }).then(function(response) {
                    const firstGeoObject = response.geoObjects.get(0);
                    if(!firstGeoObject) return;

                    const coordinates = firstGeoObject.geometry.getCoordinates();
                    self._state.map.setCenter(coordinates, 16);
                    self._elems.$form.find('input[name="building[location]"]').val(coordinates.join(','));
                });
            });
        });
    };

    _bindCompanies = (args) => {
        let self = this;

        if (!self._elems.$form.length) return;

        self._elems.$form.find('.form-group__link.add.is-create-new-company').click(function (e) {
            e.preventDefault();

            new Company({
                mode  : Vars.view.object,
                items : args.companies,
                done  : function(company){
                    args.companies.push(company);
                    [
                        'distributor_id'
                    ].forEach(function (property_name) {
                        let $select = self._elems.$form.find('select[name="building[' + property_name + ']"]');
                        $('<option />').text(ifacade.constants.companies.organizational_forms[company.organizational_form].short_name + ' "' + company.name + '"').val(company.id).appendTo($select);
                        $select.val(company.id);
                    });

                    new Modal({
                        title   : 'Создание компании',
                        content : Utils.renderProfileTemplate('info', {
                            message : 'Новая компания успешно создана. Теперь вы можете выбрать её в соответствующем списке.',
                            buttons : {
                                one : {
                                    class : 'confirm button--edit',
                                    title : 'Продолжить'
                                },
                                two : null
                            }
                        })
                    });
                }
            });
        });

        self._state.countOfExtraCompanies = Object.keys(self._state.item).length ? self._state.item.extra_companies.reduce(function(count, extra_company_id, extra_company_id_index) {
            return (extra_company_id ? extra_company_id_index + 1 : count);
        }, 0) : 0;

        self._elems.$form.find('.form-field[data-name="has_mortgage"] .checkbox').change(function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-field[data-name="has_installment"] .checkbox').change(function() {
            self._updateForm();
        });
        self._elems.$form.find('.form-group[data-name="extra_companies"] .form-group__link.add.is-add-company').click(function(e) {
            e.preventDefault();
            ++self._state.countOfExtraCompanies;
            self._updateForm({
                link : $(this)
            });
        });
        self._elems.$form.find('.form-group[data-name="extra_companies"] .select__remove').click(function(e) {
            e.preventDefault();
            let $form_group__section = $(this).closest('.form-group__section');

            const extraCompanyIds = [
                self._elems.$form.find('input[name="building[extra_company_id0]"]').val(),
                self._elems.$form.find('input[name="building[extra_company_id1]"]').val()
            ];

            extraCompanyIds.splice($form_group__section.index(), 1);
            extraCompanyIds.forEach(function(extra_company_id, index) {
                self._elems.$form.find('input[name="building[extra_company' + index + '_id]"]').val(extra_company_id);
            });

            --self._state.countOfExtraCompanies;
            self._updateForm({
                link : $(this)
            });
        });
    };

    _bindBanks = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        let $form_field = self._elems.$form.find('.form-field[data-name="bank_element_ids"]');
        let $input = $form_field.find('.input');

        if (!Object.keys(self._state.item).length) return;
        if (!self._state.item.bank_elements) return;

        let $input_text_input = $input.find('input[type="text"]');
        self._state.item.bank_elements.forEach(function (bank_element) {
            $('<div />').addClass('input-tag').html(Utils.renderTemplate('input-tag', {
                name: bank_element.title + ' ' + bank_element.name,
                description: '(№' + bank_element.number + ')',
            })).insertBefore($input_text_input);
            $('<input />').attr('type', 'hidden').attr('name', 'building[bank_element_ids][]').val(bank_element.id).insertBefore($input_text_input);
        });
        $form_field.show();
    };

    _bindSubways = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        let $form_field = self._elems.$form.find('.form-field[data-name="subway_ids"]');
        let $select = $form_field.find('select[data-name="building[subway_ids]"]');
        let $selects = $form_field.find('.selects');

        const address_element_id = self._elems.$form.find('[data-name="address"] .input').attr('data-newparentid');
        let location = self._elems.$form.find('input[name="building[location]"]').val();

        location = location ? location.split(/,/).map(function(coordinate) {
            return parseFloat(coordinate);
        }) : null;

        if (!address_element_id || !location) {
            $form_field.hide();
            return;
        }

        if (Object.keys(self._state.item).length && self._state.item.subways && self._state.item.subways.length > 0) {
            $form_field.show();
        }

        if ($selects.children().length){
            $form_field.hide();
            if ($select[0] !== undefined && $select[0].selectize !== undefined) {
                Utils.selectizeClearOptions($select[0].selectize);
                $select[0].selectize.destroy();
            }

            $select.empty();
            let inputsArr = [];
            $selects.children('input').each(function() {
                inputsArr.push($(this));
            });

            const length = inputsArr.length;
            let i = 1;

            inputsArr.sort(function(a, b){
                return Utils.getDistance(location, a.data('location').toString().split(',')) - Utils.getDistance(location, b.data('location').toString().split(','));
            }).forEach(function($input){
                const distance = Utils.getDistance(location, $input.data('location').toString().split(','));
                if(distance > 2.0)
                    $input.data('selected', 'false');

                let $option = $('<option/>')
                    .text($input.data('name'))
                    .val($input.data('id'))
                    .attr('data-id', $input.data('id'))
                    .attr('data-name', $input.data('name'))
                    .attr('data-distance', distance)
                    .attr('data-location', $input.data('location'));

                $selects.find('[value="' + $input.data('name') + '"]').attr('data-distance', distance);

                if (Object.keys(self._state.item).length && self._state.item.subways && self._state.item.subways.length){
                    self._state.item.subways.forEach(function(subway){
                        if (subway.id == $input.data('id')) {
                            $option.attr('selected', 'selected');
                            $selects.find('[value="' + $input.data('name') + '"]').data('selected', 'selected');
                        }
                    })
                }
                else if(distance <= 2.0) {
                    $option.attr('selected', 'selected');
                }

                $select.append($option);

                if(i === length) {
                    self._selectizeSubway();
                    $form_field.show();
                }

                i++;
            });
        }
        else {
            $.ajax({
                url: '/api/search_subways',
                data: {
                    address_element_id: address_element_id
                }
            }).done(function (response) {
                if (response.error) {
                    return;
                }

                if (!response.elements || response.elements.length == 0) {
                    $form_field.hide();
                    return;
                }

                $select.html('');
                $selects.html('');

                const length = response.elements.length;
                let i = 1;

                response.elements.sort(function (element0, element1) {
                    return Utils.getDistance(location, element0.location.slice(1, element0.location.length - 1).split(',')) - Utils.getDistance(location, element1.location.slice(1, element1.location.length - 1).split(','));
                }).forEach(function (element) {
                    const distance = Utils.getDistance(location, element.location.slice(1, element.location.length - 1).split(','));

                    let $option = $('<option/>')
                        .text(element.name)
                        .val(element.id)
                        .attr('data-id', element.id)
                        .attr('data-name', element.name)
                        .attr('data-location', element.location)
                        .attr('data-distance', distance);

                    let $input = $('<input/>')
                        .val(element.name)
                        .attr('type', 'hidden')
                        .attr('data-id', element.id)
                        .attr('data-name', element.name)
                        .attr('data-distance', distance)
                        .attr('data-location', element.location);

                    if(Object.keys(self._state.item).length && self._state.item.subways && self._state.item.subways.length){
                        self._state.item.subways.forEach(function(subway){
                            if (subway.id == element.id) {
                                $option.attr('selected', 'selected');
                                $input.data('selected', 'selected');
                            }
                        })
                    }
                    else if (!Object.keys(self._state.item).length && distance <= 2.0) {
                        if (($select.children(':selected').length < 3)) {
                            $option.attr('selected', 'selected');
                            $input.data('selected', 'selected');
                        }
                    }

                    $select.append($option);
                    $selects.append($input);

                    if(i === length) {
                        self._selectizeSubway();
                        $form_field.show();
                    }

                    i++;
                });

            });
        }

        self._elems.$form.find('.form-field[data-name="subway_ids"] .input').attr('data-url', '/api/search_subways?address_element_id=' + address_element_id);
    };

    _selectizeSubway = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        let $form_field = self._elems.$form.find('.form-field[data-name="subway_ids"]');
        let $select = $form_field.find('select[data-name="building[subway_ids]"]');
        let $selects = $form_field.find('.selects');

        let location = self._elems.$form.find('input[name="building[location]"]').val();

        location = location ? location.split(/,/).map(function(coordinate) {
            return parseFloat(coordinate);
        }) : null;

        let $selectize = $select.selectize({
            theme: 'result',
            valueField: 'id',
            labelField: 'name',
            searchField: 'name',
            options: [],
            create: false,
            render: {
                item: function (item, escape) {
                    let $input = $selects.find('[value="' + item.name + '"]');
                    $input.data('selected', 'selected');
                    const distance = $input.attr('data-distance');
                    const distanceText = '(' + (distance < 1.0 ? Math.round(distance * 1000) : Math.round(distance * 100) / 100) + ' ' + (distance < 1.0 ? 'м' : 'км') + '.)';
                    const html = '<div class="item" data-value="' + item.name + '"><span class="input-tag__name">' + item.name + '</span>' + '<span class="input-tag__description"> ' + distanceText + '</span><a href="#" class="input-tag__close"><i class="fa fa-close"></i></a></div>';
                    return html;
                },
                option: function (item, escape) {
                    let $option = $select.children('[data-name="' + item.name + '"]');
                    return '<div class="option" data-distance="' + $option.data('distance') + '">' + escape(item.name) + '</div>';
                }
            },
            onItemAdd: function (value, $item) {
                const name = $item.children('.input-tag__name').text();
                let $input = $selects.find('[value="' + name + '"]');

                $input.data('selected', 'selected');

                $item.find('.input-tag__close').click(function(){
                    const id = $(this).parents('.item').data('value');
                    let $input = $selects.find('input[data-id="' + id + '"]');

                    $input.data('selected', 'false');

                    Utils.selectizeClearOptions($selectize[0].selectize);
                    $selectize[0].selectize.destroy();

                    $select.html('');

                    let inputsArr = [];
                    $selects.children('input').each(function() {
                        inputsArr.push($(this));
                    });

                    const length = inputsArr.length;
                    let i = 1;

                    inputsArr.sort(function(a, b){
                        const aLocation = (typeof a.data('location') == 'object') ? a.data('location') : a.data('location').split(',');
                        const bLocation = (typeof b.data('location') == 'object') ? b.data('location') : b.data('location').split(',');
                        return Utils.getDistance(location, aLocation) - Utils.getDistance(location, bLocation);
                    }).forEach(function($input){
                        const iLocation = (typeof $input.data('location') == 'object') ? $input.data('location') : $input.data('location').split(',');
                        const distance = Utils.getDistance(location, iLocation);

                        let $option = $('<option/>')
                            .text($input.data('name'))
                            .val($input.data('id'))
                            .attr('data-id', $input.data('id'))
                            .attr('data-name', $input.data('name'))
                            .attr('data-distance', distance)
                            .attr('data-location', $input.data('location'));

                        $input = $selects.find('[value="' + $input.data('name') + '"]');
                        $input.attr('data-distance', distance);

                        if($input.data('selected') == 'selected') {
                            $option.attr('selected', 'selected');
                        }

                        $select.append($option);

                        if(i === length) {
                            self._selectizeSubway();
                            $form_field.show();
                        }

                        i++;
                    });

                    return false;
                });
            }
        });

        $form_field.find('.input-tag__close').click(function(){
            const id = $(this).parents('.item').data('value');
            let $input = $selects.find('input[data-id="' + id + '"]');

            $input.data('selected', 'false');

            Utils.selectizeClearOptions($selectize[0].selectize);
            $selectize[0].selectize.destroy();

            $select.html('');

            let inputsArr = [];
            $selects.children('input').each(function() {
                inputsArr.push($(this));
            });

            const length = inputsArr.length;
            let i = 1;

            inputsArr.sort(function(a, b){
                const aLocation = typeof a.data('location') == 'object' ? a.data('location') : a.data('location').split(',');
                const bLocation = typeof b.data('location') == 'object' ? b.data('location') : b.data('location').split(',');
                return Utils.getDistance(location, aLocation) - Utils.getDistance(location, bLocation);
            }).forEach(function($input){
                const iLocation = (typeof $input.data('location') == 'object') ? $input.data('location') : $input.data('location').split(',');
                const distance = Utils.getDistance(location, iLocation);

                let $option = $('<option/>')
                    .text($input.data('name'))
                    .val($input.data('id'))
                    .attr('data-id', $input.data('id'))
                    .attr('data-name', $input.data('name'))
                    .attr('data-distance', distance)
                    .attr('data-location', $input.data('location'));

                $input = $selects.find('[value="' + $input.data('name') + '"]');
                $input.attr('data-distance', distance);

                if($input.data('selected') == 'selected') {
                    $option.attr('selected', 'selected');
                }

                $select.append($option);

                if(i === length) {
                    self._selectizeSubway();
                    $form_field.show();
                }

                i++;
            });

            return false;
        });
    };

    _bindDistricts = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        if(self._state.ajax && self._state.ajax['update_districts'] !== undefined) {
            self._state.ajax['update_districts'].abort();
        }

        let $form_field = self._elems.$form.find('.form-field[data-name="district_id"]');
        let $select = self._elems.$form.find('select[name="building[district_id]"]');
        let $selects = $form_field.find('.selects');
        const $value = $select.val();

        const address_element_id = self._elems.$form.find('[data-name="address"] .input').attr('data-newparentid');

        if (!address_element_id) {
            $form_field.hide();
            self._elems.$form.find('select[name="building[district_id]"]').html('');
            return;
        }

        $form_field.show();

        self._state.ajax['update_districts'] = $.ajax({
            url: '/api/address_elements/' + address_element_id + '/districts',
        }).done(function(response) {
            if (response.error) {
                return;
            }

            if (response.districts.length == 0) {
                self._elems.$form.find('select[name="building[district_id]"]').html('');
                self._elems.$form.find('.form-field[data-name="district_id"]').hide();
                return;
            }

            $select.html('');
            $('<option />').appendTo($select);

            response.districts.forEach(function(district) {
                $('<option />')
                    .attr('value', district.id)
                    .attr('data-okato0', district.okato0)
                    .attr('data-okato1', district.okato1)
                    .attr('data-okato2', district.okato2)
                    .attr('data-okato3', district.okato3)
                    .text(district.part_name)
                    .appendTo($select);

                $('<input />')
                    .attr('value', district.id)
                    .attr('type', 'hidden')
                    .attr('data-okato0', district.okato0)
                    .attr('data-okato1', district.okato1)
                    .attr('data-okato2', district.okato2)
                    .attr('data-okato3', district.okato3)
                    .attr('data-name', district.part_name)
                    .appendTo($selects);
            });

            self._elems.$form.find('.form-field[data-name="district_id"]').show();
            if (Object.keys(self._state.item).length) {
                if(self._state.item.district_id) {
                    $select.val(self._state.item.district_id);
                }
            }
            else {
                if($value) {
                    $select.val($value);
                }
                self._updateSelectedDistrict();
            }
        });

        self._elems.$form.find('.form-field[data-name="district_id"]').show();
    };

    _updateSelectedDistrict = () => {
        let self = this;

        if (!self._elems.$form.length) return;

        if (self._state.ajax && self._state.ajax['update_selected_district'] !== undefined) {
            self._state.ajax['update_selected_district'].abort();
        }

        const address_element_id = self._elems.$form.find('input[name="building[address_element_id]"]').val();
        const address_number = self._elems.$form.find('input[name="building[address_number]"]').val();

        let $form_field = self._elems.$form.find('.form-field[data-name="district_id"]');
        let $select = self._elems.$form.find('select[name="building[district_id]"]');
        let $selects = $form_field.find('.selects');
        let msgInfo = $select.parent().prev('.msg-info');

        $select.change(function(){
            if(self._state.ajax['update_selected_district'] !== undefined) {
                self._state.ajax['update_selected_district'].abort();
            }

            $select.parent().prev('.msg-info').remove();
            $select.parent().removeClass('loading');
        });
    };

    _bindSubmit = (args) => {
        let self = this;

        let $modal = args.modal;
        if (!$modal.length) return;
        let $form = $modal.find('form');
        if (!$form.length) return;

        const errors = $form.find('.form-field.error').length;

        if(errors) return;

        loader.increase();

        Request.send({
            path   : '/api/objects/' + self._args.objectId + '/' + self._const.entities + '/' + (Object.keys(self._state.item).length ? self._state.item.id + '/edit' : 'create'),
            method : 'POST',
            data   : $form.serialize(),

            done: function(response) {
                loader.decrease();

                if (response.error) {
                    self._utils.validation.showErrors(response.error);
                    return
                }

                $modal.trigger('close');

                if(self._args.mode === Vars.view.object && !Object.keys(self._state.item).length) {
                    window.location.href = '/profile#objects/' + self._state.object.id  + '/' + self._const.entities + '/' + response[self._const.entity].id;
                }
                else if (self._args.mode === Vars.view.object) {
                    window.location.reload();
                }
                else {
                    self._state.item   = response[self._const.entity];
                    self._state.items  = {};
                    self._state.tariff = response.tariff;

                    self._state.object = self._state.item.object;

                    let dropdown = Utils.renderProfileTemplate(self._const.entity + '-dropdown', {
                        object   : self._state.object,
                        building : self._state.item,
                        tariff   : self._state.tariff
                    });

                    self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                        crumbs : [
                            {
                                title : 'Жилые комплексы',
                                href  : '#objects'
                            },
                            {
                                title : self._state.object.name,
                                href  : '#objects/' + self._state.object.id
                            },
                            {
                                title : self._state.item.name ? self._state.item.name : 'Дом №' + self._state.item.number
                            }
                        ],
                        dropdown : dropdown,
                        activate : {
                            id        : self._state.item.id,
                            is_active : self._state.item.is_active
                        }
                    });

                    self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                        breadcrumbs                 : self._state.breadcrumbs,
                        [self._const.entity]        : self._state.item,
                        [self._const.parent.entity] : self._state.item.object,
                        tariff                      : self._state.tariff
                    }));

                    window.chess = self._state.chess = new Chess({
                        object               : self._state.object,
                        [self._const.entity] : self._state.item,
                        progress             : self._state.progress,
                        buildingSelf         : self
                    });

                    self._bindElements();
                    self._bindUI();

                    self._bindActions();

                    self._state.progress.update({
                        object : self._state.object
                    });
                }
            }
        });
    };

    _bindUI = () => {
        let self = this;

        self._elems.$create.length && self._elems.$create.unbind('click').on('click', function(e) {
            e.preventDefault();

            loader.increase();
            Request.send({
                queue : [
                    {
                        path: '/api/objects/' + self._args.objectId + '?mode=for_building'
                    },
                    {
                        path: '/api/options?only=companies'
                    }
                ],
                path: '/api/options?only=companies',
                done : function(response, extraResponse) {
                    loader.decrease();
                    Utils.scrollToTop();

                    self._state.object.typical_plans = response.object.typical_plans;

                    let args = extraResponse.options ? extraResponse.options : [];
                    self._initModal(args);
                }
            });
        });

        self._elems.$edit.length && self._elems.$edit.unbind('click').on('click', function(e) {
            e.preventDefault();

            loader.increase();

            const id = self._args.mode === Vars.view.object ? $(this).data('id') : self._state.item.id;

            Request.send({
                queue: [
                    {
                        path: '/api/objects/' + self._state.object.id + '/' + self._const.entities + '/' + id
                    },
                    {
                        path: '/api/options?only=companies'
                    }
                ],
                done : function(response, extraResponse) {
                    loader.decrease();
                    Utils.scrollToTop();

                    self._state.item   = response[self._const.entity];
                    self._state.items  = {};
                    self._state.object = self._state.item.object;

                    let args = extraResponse.options ? extraResponse.options : [];
                    self._initModal(args);
                }
            });
        });

        self._bindActions();
    };

    _object= () => {
        let self = this;

        self._bindElements();
        self._bindUI();
    };

    _item = () => {
        let self = this;

        Request.send({
            path: '/api/objects/' + self._args.objectId + '/' + self._const.entities + '/' + self._args.id,
            data: {
                info: 'short'
            },
            done: function(response) {
                loader.decrease();

                if (response.error) {
                    return Utils.notFound({
                        message  : 'Запрашиваемый дом не найден',
                        redirect : '#objects/' + self._args.objectId
                    });
                }

                self._state.item   = response[self._const.entity];
                self._state.items  = {};
                self._state.tariff = response.tariff;

                self._state.object = self._state.item.object;

                let dropdown = Utils.renderProfileTemplate(self._const.entity + '-dropdown', {
                    object   : self._state.object,
                    building : self._state.item,
                    tariff   : self._state.tariff
                });

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Жилые комплексы',
                            href  : '#objects'
                        },
                        {
                            title : self._state.object.name,
                            href  : '#objects/' + self._state.object.id
                        },
                        {
                            title : self._state.item.name ? self._state.item.name : 'Дом №' + self._state.item.number
                        }
                    ],
                    dropdown : dropdown,
                    activate : {
                        id        : self._state.item.id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity, {
                    breadcrumbs          : self._state.breadcrumbs,
                    object               : self._state.object,
                    [self._const.entity] : self._state.item,
                    tariff               : self._state.tariff
                }));

                self._bindProgress();

                window.chess = self._state.chess = new Chess({
                    object               : self._state.object,
                    [self._const.entity] : self._state.item,
                    progress             : self._state.progress,
                    buildingSelf         : self
                });

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _import = () => {
        let self = this;

        Request.send({
            path: '/api/objects/' + self._args.objectId + '/' + self._const.entities + '/' + self._args.id,
            data: {
                info: 'for_import'
            },
            done: function(response) {
                loader.decrease();
                Utils.scrollToTop();

                self._state.item   = response[self._const.entity];
                self._state.items  = {};

                self._state.object = self._state.item.object;

                self._state.breadcrumbs = Utils.renderProfileTemplate('breadcrumbs', {
                    crumbs : [
                        {
                            title : 'Жилые комплексы',
                            href  : '#objects'
                        },
                        {
                            title : self._state.object.name,
                            href  : '#objects/' + self._state.object.id
                        },
                        {
                            title : self._state.item.name ? self._state.item.name : 'Дом №' + self._state.item.number,
                            href  : '#objects/' + self._state.object.id + '/buildings/' + self._state.item.id
                        },
                        {
                            title : 'Импорт предложений из XLS'
                        }
                    ],
                    dropdown : null,
                    activate : {
                        id        : self._state.item.id,
                        is_active : self._state.item.is_active
                    }
                });

                self._elems.$content.html(Utils.renderProfileTemplate(self._const.entity + '-import', {
                    breadcrumbs          : self._state.breadcrumbs,
                    object               : self._state.object,
                    [self._const.entity] : self._state.item,
                    tariff               : self._state.tariff
                }));

                self._elems.$form = self._elems.$content.find('#import-form');
                self._setDropzone();

                let $dropzone = self._elems.$content.find('.dropzone');
                if (!$dropzone.length) return;

                new Dropzone({
                    root   : $dropzone,
                    form   : self._elems.$form,
                    items  : self._state.dropzone.items,
                    entity : self._const.entities
                });

                self._bindElements();
                self._bindUI();
            }
        });
    };

    _init = () => {
        let self = this;

        self._bindElements();

        if (self._args.mode === Vars.view.object) {
            self._object();
        } else if (self._args.mode === Vars.view.item) {
            self._item();
        } else if (self._args.mode === Vars.view.import) {
            self._import();
        }
    }
}

export default Building;